import React, { useEffect, useState } from "react";
import Container from "../../common/Container";
import Action from "../../common/Actions"
import "../../index.css";
import SearchIcon from "@mui/icons-material/Search";
import InputWithIcon from "../../common/InputWithIcon";
import { TH, TD, TR, Thead, Tbody } from "../../styled/table";
import Add from "@mui/icons-material/Add";
import Button from "../../common/Button";
import PaginationDiv from "../../common/PaginationDiv";
import CustomAddPage from "../../components/custom-pages/CustomAddModal"
import { createDocument, deleteDocumentById, getAllData } from "../../apis/customApiHandler";
import { convertToIndianTimezoneAndGetDate, handleDownClick, handleUpClick } from "../../utils/helpers";
import { LinearProgress } from "@mui/material";
import checkPermission from "../../utils/checkPermission";
import { DisabledByDefault } from "@mui/icons-material";

function ProductCategory() {
  const [limit, setLimit] = useState(10);
  const [page, setPage] = React.useState(1);
  const [search, setSearch] = useState("")
  const [productCategories, setProductCategories] = useState([])
  const [productCategory, setProductCategory] = useState({})
    const [totalData, setTotalData] = useState(0);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showAddModal, setShowAddModal] = useState(false);
  const [loading, setLoading] = useState(false)
  const currentUser = JSON.parse(localStorage.getItem("user"))


  const getProductCategory = async () => {
    setLoading(true)
    const data = await getAllData("/master/product/getProductCategory", {page, limit, search});
    setProductCategories(data?.data)
    setTotalData(data?.totalData)
    setLoading(false)
  }
  useEffect(() => {
    getProductCategory();
  }, [search, limit, page ])

  const list = [
    {
      name: "Edit",
     condition: checkPermission([
    {
        permission: "masters",
        subPermission: ["UPDATE"]
    },
], currentUser),
      onClick: (productCategory) => {
        setProductCategory(productCategory);
        setShowEditModal(true);
      },
      className: "text-grey",
    },
    {
      name: "Delete",
     condition: checkPermission([
    {
        permission: "masters",
        subPermission: ["DELETE"]
    },
], currentUser),
      onClick: async (productCategory) => {
        setProductCategory(productCategory);
        await createDocument("/master/product/updateProductCategory?_id=" +  productCategory?._id, {deleted: true});
        await getProductCategory()
      },
      className: "text-error",
    },
  ];
  return (
    <Container>
      <div className="flex flex-col md:flex-row justify-between">
        <div className="grid grid-col-1 col-span-2 md:col-span-1 flex flex-col">
          <div className="font-semibold text-[24px]"> Product Category</div>
        </div>

        <div className="flex flex-row text-secondary h-12 gap-3 text-xl">
          {/* <div className="">
            <Button
              text="Add New Product Category"
              disabled = {!checkPermission([
                {
                    permission: "masters",
                    subPermission: ["CREATE"]
               ,},
            ], currentUser)}
              className="w-full flex flex-row border border-1 border-black items-center px-3 rounded-md h-12 text-[16px] font-medium text-white bg-dark-blue gap-3"
              Icon={<Add color="inherit" />}
              onClick={() => setShowAddModal(true)}
            />
          </div> */}
        </div>
      </div>
      <div className="mt-5">
        <InputWithIcon
          placeholder="Search for Product Category..."
          variant="outlined"
          setData={setSearch}
          Icon={<SearchIcon className="text-dark-grey" />}
          className="w-80 border border-gray-300 items-center px-2 rounded-md h-12 text-[16px] shadow-sm"
          inputClass="text-[16px]"
        />
      </div>
      <table className="w-full table">
        <Thead className="flex flex-row justify-between w-full">
          <tr className=" flex flex-row justify-between w-full">
            {/* <TH className="" type="checkbox"> <input type="checkbox"></input></TH> */}
            <TH handleUpClick= {handleUpClick} handleDownClick={handleDownClick} setData={setProductCategories} field={"CatCode"} > Code</TH>
            <TH handleUpClick= {handleUpClick} handleDownClick={handleDownClick} setData={setProductCategories} field={"Ydesc"} > Description</TH>
            <TH handleUpClick= {handleUpClick} handleDownClick={handleDownClick} setData={setProductCategories} field={"twi"} > TWI</TH>
            <TH handleUpClick= {handleUpClick} handleDownClick={handleDownClick} setData={setProductCategories} field={"createdAt"} > Created On</TH>
            <TH> Actions</TH>
          </tr>
        </Thead>
        {loading ? <LinearProgress color="secondary" /> :
          <Tbody className="flex flex-col justify-between w-full">
            {productCategories?.length ? productCategories?.map((entry, index) => {
              if (true)
                return (
                  <TR className="">
                    {/* <TD className="ml-2 text-center justify-center " type="checkbox"> <input type="checkbox"></input> </TD> */}
                    <TD> {entry.CatCode} </TD>
                    <TD> {entry.Ydesc} </TD>
                    <TD> {entry.twi} </TD>
                    <TD> {convertToIndianTimezoneAndGetDate(entry.createdAt)} </TD>
                    <TD className="text-center">
                      {/* --- */}
                       <Action list={list} data={entry} /> 
                       </TD>
                  </TR>
                );
            }): <div className= "w-full text-semibold text-center text-lightGrey p-3"> No Data Found </div>}
          </Tbody>
        }
      </table>
      <PaginationDiv
        page={page}
        setPage={setPage}
        length={totalData}
        limit={limit}
        setLimit={setLimit}
      />
      {showAddModal && <Create handleClick={async () => { setShowAddModal(false); await getProductCategory() }} />}
      {showEditModal && <Create data={productCategory} handleClick={async () => { setShowEditModal(false); await getProductCategory() }} />}
    </Container>
  )
}
function Create({ data, handleClick }) {
  console.log('data22',data);
  const [initialValues, setInitialValues] = React.useState({
    Code: data?.name || "",
    description: data?.Ydesc || "",
    name: data?.CatCode || "",
    twi:data?.twi || ""
  });

  const inputFields = [
    {
      name: "name",
      label: "Code",
      type: "text",
      disabled:"true"
      // required: true,
    },
    {
      name: "description",
      label: "Description",
      type: "text",
      disabled:"true"
      // required: true,
    },
    {
      name: "twi",
      label: "TWI",
      type: "text",
    },
  ];
  return (
    <CustomAddPage
      pageTitle={data ? "Update Product Category" : "Add Product Category"}
      url={data ? "/master/product/updateProductCategory" : "/master/product/addProductCategory"}
      action={!data ? "create" : "post"}
      updateId={data?._id}
      queryKey="ProductCategory"
      inputFields={inputFields}
      data={initialValues}
      setData={setInitialValues}
      handleClick={handleClick}
    />
  );
}
export default ProductCategory